import { Platform, ViewStyle } from 'react-native';

type WebOnlyStyles = {
  cursorPointer: ViewStyle;
  cursorDefault: ViewStyle;
  noSelect: ViewStyle;
  transition: (property?: string, duration?: string, easing?: string) => ViewStyle;
  backdropBlur: (radius?: number) => ViewStyle;
  /**
   * Let a word longer than its line wrap mid-word (an e-mail address as a
   * subject). Native text already breaks long words; the browser only clips.
   */
  breakWord: ViewStyle;
};

const webStyles: WebOnlyStyles = {
  cursorPointer: { cursor: 'pointer' } as any,
  cursorDefault: { cursor: 'default' } as any,
  noSelect: { userSelect: 'none' } as any,
  transition: (property = 'all', duration = '0.15s', easing = 'ease') =>
    ({ transition: `${property} ${duration} ${easing}` }) as any,
  backdropBlur: (radius = 16) => ({
    backdropFilter: `blur(${radius}px)`,
    WebkitBackdropFilter: `blur(${radius}px)`,
  }) as any,
  breakWord: { wordBreak: 'break-word' } as any,
};

const emptyProxy: WebOnlyStyles = {
  cursorPointer: {},
  cursorDefault: {},
  noSelect: {},
  transition: () => ({}),
  backdropBlur: () => ({}),
  breakWord: {},
};

export const WEB_STYLES: WebOnlyStyles = Platform.OS === 'web' ? webStyles : emptyProxy;
